<template>
    <teleport to="head">
        <component is="script" type="application/ld+json" v-text="jsonSchema"></component>
    </teleport>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
    schema: Object
});

const jsonSchema = computed(() => {
    return JSON.stringify(props.schema);
});
</script>

<style scoped>

</style>
